export { default } from "ember-keyboard/services/keyboard";
